import React from "react";
import Header from "../../components/header";
import Main from "../../components/landing/main";
import { Typography, Grid, Box, Container, Button } from "@mui/material";
import Section2 from "../../components/landing/trans";
import Section3 from "../../components/landing/fixelpay";
import Section4 from "../../components/landing/end";

export default function Index() {
  return (
    <div>
      <Header />
      <div style={{ padding: "20px" }}>
        <Main />
      </div>
      <div className="strip"></div>
      <div className="lower_sec_main">
        <Container>
          <Grid container justifyContent="center">
            <Grid
              item
              sx={{ textAlign: "center" }}
              xs={11}
              md={10}
              lg={10}
              mt={15}
            >
              <Typography className="lower_typo1">
                Seamlessly connect and transact across the continent and world
                😎🛍️️️.
              </Typography>
              <Typography className="lower_typo2" sx={{ mt: 2 }}>
                Our seamless products make doing business in UK cheaper, faster,
                and fun.
              </Typography>
            </Grid>
            <Box sx={{ mt: 15 }}>
              <Section2 />
            </Box>
            <Box sx={{ mt: 20 }}>
              <Section3 />
            </Box>
            <Box sx={{ mt: 20 }}>
              <Section4 />
            </Box>
            <Grid
              item
              sx={{ textAlign: "center" }}
              xs={11}
              md={10}
              lg={10}
              mt={15}
              mb={15}
            >
              <Typography className="lower_typo1">
                Seamlessly connect and transact across the continent and world
                😎🛍️️️.
              </Typography>
              <Typography className="lower_typo2" sx={{ mt: 2 }}>
                Our seamless products make doing business in UK cheaper, faster,
                and fun.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
}
